import React, { useState } from 'react';
import './ActivitiesModal.css';
import { formatNumber, formatDate } from '../utils/formatters';
import { ACTIVITY_TYPES } from '../config/contract';

const ActivitiesModal = ({ activities, onClose }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  const totalPages = Math.ceil(activities.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedActivities = activities.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="activities-overlay" onClick={onClose}>
      <div className="activities-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>

        <div className="activities-header">
          <div className="header-icon">📜</div>
          <h2>All Activities</h2>
          <p>{activities.length} total activities</p>
        </div>

        <div className="activities-timeline">
          {paginatedActivities.length > 0 ? (
            paginatedActivities.map((activity, index) => {
              const info = ACTIVITY_TYPES[activity.activityType] || { 
                name: 'Activity', 
                icon: '📌', 
                color: '#00ff88' 
              };
              
              return (
                <div 
                  key={activity.id || index} 
                  className="timeline-item"
                  style={{ '--item-delay': `${index * 0.05}s` }}
                >
                  <div className="timeline-connector">
                    <div className="connector-line"></div>
                    <div className="connector-dot" style={{ background: info.color }}></div>
                  </div>
                  
                  <div className="timeline-content">
                    <div className="activity-card">
                      <div className="activity-icon" style={{ background: info.color }}>
                        {info.icon}
                      </div>
                      <div className="activity-details">
                        <span className="activity-type">{info.name}</span>
                        {parseFloat(activity.amount) > 0 && (
                          <span className="activity-amount">
                            ${formatNumber(activity.amount)} USDT
                          </span>
                        )}
                        {activity.fromId > 0 && (
                          <span className="activity-from">
                            From: #{activity.fromId}
                          </span>
                        )}
                        {activity.packageId > 0 && (
                          <span className="activity-pkg">
                            Unit: {activity.packageId}
                          </span>
                        )}
                      </div>
                      <div className="activity-meta">
                        <span className="activity-time">{formatDate(activity.timestamp)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-activities">
              <span className="empty-icon">🕐</span>
              <p>No activities recorded yet</p>
            </div>
          )}
        </div>

        {totalPages > 1 && (
          <div className="activities-pagination">
            <button
              className="page-btn"
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
            >
              ««
            </button>
            <button
              className="page-btn"
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
              disabled={currentPage === 1}
            >
              ←
            </button>
            
            <span className="page-indicator">
              {currentPage} / {totalPages}
            </span>
            
            <button
              className="page-btn"
              onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
            >
              →
            </button>
            <button
              className="page-btn"
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
            >
              »»
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivitiesModal;
